import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredQualityAlerts,
  selectQualityAlertFilterVisible,
  selectQualityAlertLoading,
  selectfetchQualityAlertLoading,
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { AlertCircle, AlertTriangle, Trash2 } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { editQualityAlert, editQualityAlertData, fetchQualityAlertByPartId } from './store/slice';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { showModal } from '../../core/redux/main/slice';
import { MODAL_TYPES } from '../components/app-modals';

const { QUALITYALERT_ADD_EDIT } = MODAL_TYPES;

const QualityAlertTile = props => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const qualityAlertTileRef = useRef(null);

  const filteredQualityAlerts = useSelector(selectFilteredQualityAlerts);
  const isLoading = useSelector(selectQualityAlertLoading);
  const filterVisible = useSelector(selectQualityAlertFilterVisible);
  const isFetchDataLoading = useSelector(selectfetchQualityAlertLoading);
  const headerVisible = useSelector(isHeaderVisible);

  const updateColumnSettings = useCallback(() => {
    if (qualityAlertTileRef.current) {
      const width = qualityAlertTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(Math.max(width / columns, 180));
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  const itemData = filteredQualityAlerts.map(p => <Tile part={p} />);
  return (
    <div
      className={`tile-body ${filterVisible ? 'filter-visible' : ''} ${
        !headerVisible ? 'header-collapsed' : ''
      }`}
      ref={qualityAlertTileRef}
    >
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredQualityAlerts.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={125} // Adjusted row height
        />
      }
    </div>
  );
};
const MySwal = withReactContent(Swal);

const Tile = ({ part }) => {
  const dispatch = useDispatch();

  const handleAlertClick = async e => {
    e.stopPropagation();
    // dispatch(editQualityAlertData(part.id));
    const response = await dispatch(fetchQualityAlertByPartId(part.id));
    const payload = response?.payload;

    dispatch(
      showModal(QUALITYALERT_ADD_EDIT, {
        id: part.id,
        isReadOnly: Boolean(payload?.id), // If data exists, open in read-only
      }),
    );
  };

  return (
    <div key={part || Math.random()} className="tile">
      <div
        className={`card p-3 m-2`} //${part.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions">
          <ButtonGroup size="sm">
            <Button variant="light" onClick={handleAlertClick}>
              <AlertCircle size={24} color="orange" strokeWidth={2.5} />
            </Button>
            {/* <Button variant="light" onClick={handleDelete}>
              <Trash2 size={16} />
            </Button> */}
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="c-details">
              <h6>
                {part.partNumber}{' '}
                {part.isAlerts === 'Yes' && <span style={{ fontSize: '1.25rem' }}>⚠️</span>}
              </h6>
            </div>
            <div className="tile-descriptionText text-truncate w-85">
              <span className="tile-description">{part.description}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default QualityAlertTile;
